import React from "react";
import {createListFromArray, createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";
import {
    Button,
    convertInputFormToObject,
    InputForm,
    inputStyles,
    useInputForm,
    DateTimePickerField,
    SelectField,
    TextField,
} from "../../../../Components/Inputs";
import {clearInputFormFields, createYesNoList} from "../../../../Components/Inputs/inputUtility";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {SearchableSingleSelectField} from "../../../../Components/Inputs/SearchableSingleSelectField";
import {LOAN_LIBRARY_LOAN_STATUS_LIST} from "./loanLibraryLoanConstants";
import {isAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";

interface LoanLibraryLoanSearchFormViewProps {
    districts: Record<string, any>[];
    handleSetLoanLibraryLoanSearchCriteria: (criteria: Record<string, any>) => void;
    isLoading: boolean;
    loanLibraryLoanSearchCriteria: Record<string, any>;
    loanLibraryLoanSearchDropDowns: Record<string, any>;
}

export const LoanLibraryLoanSearchFormView = ({
                                                  districts,
                                                  handleSetLoanLibraryLoanSearchCriteria,
                                                  isLoading,
                                                  loanLibraryLoanSearchCriteria,
                                                  loanLibraryLoanSearchDropDowns,
                                              }: LoanLibraryLoanSearchFormViewProps) => {

    const criteriaWithDefaults = {
        ...loanLibraryLoanSearchCriteria,
        searchKeyword: loanLibraryLoanSearchCriteria.searchKeyword ?? "",
    };

    const searchForm = useInputForm(criteriaWithDefaults);

    const patrons = createListFromArrayOfObjects(loanLibraryLoanSearchDropDowns.patrons, "userId", "fullName");
    const shippingLocations = createListFromArrayOfObjects(loanLibraryLoanSearchDropDowns.shippingLocations, "shippingLocationId", "name");
    const organizations = createListFromArray(loanLibraryLoanSearchDropDowns?.organizations);

    const handleClearClick = () => {
        clearInputFormFields(searchForm);
        const updatedLoanSearchCriteria = {...loanLibraryLoanSearchCriteria};
        updatedLoanSearchCriteria.ClearLoanLibraryLoanSearch();
        handleSetLoanLibraryLoanSearchCriteria(updatedLoanSearchCriteria);
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(searchForm);
        const updatedLoanSearchCriteria = {...loanLibraryLoanSearchCriteria};
        updatedLoanSearchCriteria.Search(criteria);
        handleSetLoanLibraryLoanSearchCriteria(updatedLoanSearchCriteria);
    };

    const inputSharedSettings = {
        medium_columns: gridConstants.column.FOUR,
    };

    return <>
        <InputForm name={"loanLibraryLoanSearch"} hasPaddingY>

            <TextField
                {...searchForm.searchKeyword}
                {...inputSharedSettings}
                label={'Search'}
                placeholder={'Product Name, Catalog#, Serial#, Keywords'}
            />

            <SearchableSingleSelectField
                {...searchForm.userId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Patron'}
                options={patrons}
            />

            <SearchableSingleSelectField
                {...searchForm.shippingLocationId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Shipping Location'}
                options={shippingLocations}
            />

            <DateTimePickerField
                {...searchForm.dueDate}
                {...inputSharedSettings}
                label={'Due Date'}
            />

            <DateTimePickerField
                {...searchForm.checkoutDate}
                {...inputSharedSettings}
                label={'Checkout Date'}
            />

            <SelectField
                {...searchForm.loanLibraryLoanStatus}
                {...inputSharedSettings}
                label={'Status'}
                options={LOAN_LIBRARY_LOAN_STATUS_LIST}
                includeDefaultOption
            />

            <SelectField
                {...searchForm.isOverdue}
                {...inputSharedSettings}
                includeDefaultOption
                options={createYesNoList()}
            />
            {
                isAdmin() &&
                <SearchableSingleSelectField
                    {...searchForm.districtId}
                    {...inputSharedSettings}
                    defaultOption={"All"}
                    includeDefaultOption
                    label={'District'}
                    options={createListFromArrayOfObjects(districts, "id", "districtName")}
                />
            }
            <SearchableSingleSelectField
                {...searchForm.organization}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Organization'}
                options={organizations}
            />

            <GridCell>
                <GridContainer hasPaddingX isFlush isReverseOrder>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.SEARCH}
                            disabled={isLoading}
                            label="Search"
                            name="btnSearchLoanLibraryLoan"
                            onClick={handleSearchClick}
                            isPrimary
                        />
                    </GridCell>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.CLEAR}
                            disabled={isLoading}
                            name="btnClearLoanLibraryLoanSearch"
                            onClick={handleClearClick}
                            label="Clear"
                        />
                    </GridCell>

                </GridContainer>
            </GridCell>

        </InputForm>
    </>;
};
